import { fn_removeOrderNew, fn_set_customer_pop, fn_set_customer_ygy_pop } from "./FnBodyDetail";
import { api_end_order_list } from "../http/EndOrderConn";
import { reload_order_list_all } from "../http/OrderConn";
import { select_access_token } from "../http/TokenConn";
import { fn_init_info } from "./FnBodyInit";
import { fn_bridge_print, fn_bridge_order_cancel_pos } from "./FnPosBridge";
import { analyticeEvent, hungryPandaMobileOrderFg } from "utils/Utils";
import { MobileOrderFg } from "types";

/**
 * 레이어 함수
 */

// 고객 예상수령시간 팝업 type체크
export function fn_layerCstType(rootStore, mobileOrderNo, mobileOrderFg) {
  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
  if (mobileOrderFg == "31" || (mobileOrderFg == "27" && rootStore.viewStore.getOrderDetail.morderTypeCd == "P")) {
    fn_layerCstYgyView(rootStore, mobileOrderNo, mobileOrderFg);
  } else {
    if (
      rootStore.viewStore.getOrderDetail.morderTypeCd == "P" ||
      rootStore.viewStore.getOrderDetail.morderTypeCd == "O"
    ) {
      fn_layerYgyFixed(rootStore, mobileOrderNo);
    } else {
      fn_layerCstView(rootStore, mobileOrderNo, "orderAcceptCard Button");
    }
  }
}

// 고객 예상수령시간 팝업
export function fn_layerCstView(rootStore, mobileOrderNo, bnt) {
  analyticeEvent("orderAccept", bnt, rootStore.searchStore.getShopCd); //GA4
  fn_removeOrderNew(rootStore, mobileOrderNo);

  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);

  rootStore.viewStore.initCustomerPopBtn();
  let time = "0";
  let view_time = "now";
  if (rootStore.viewStore.getOrderDetail.orderType === "DELIVERY") {
    if (rootStore.settingStore.getDeliveryDfTime !== "0") {
      view_time = "min" + rootStore.settingStore.getDeliveryDfTime;
    }
    time = rootStore.settingStore.getDeliveryDfTime;
  } else {
    if (rootStore.settingStore.getCookingDfTime !== "0") {
      view_time = "min" + rootStore.settingStore.getCookingDfTime;
    }
    time = rootStore.settingStore.getCookingDfTime;
  }

  //헝그리판다 조리시간 입력
  if (hungryPandaMobileOrderFg(rootStore.viewStore.getOrderDetail.mobileOrderFg)) {
    if (rootStore.settingStore.getCookingDfTime !== "0") {
      view_time = "min" + rootStore.settingStore.getCookingDfTime;
    }
    time = rootStore.settingStore.getCookingDfTime;
  }

  rootStore.layerStore.setChangeCstTime(time);
  fn_set_customer_pop(rootStore, view_time);
  rootStore.layerStore.setLayerCstExpectTime(true);
}

// 요기요 고객 가능 예상수령시간
export function fn_layerCstYgytimeList(rootStore, data) {
  let setMin;
  let time = ["5", "10", "15", "20", "25", "30"];
  let timeList = [];
  let num = Number(data.localCookingDfTime);

  if (num < 5) {
    timeList = time;
    setMin = timeList[0];
  } else if (num > 30) {
    setMin = data.localCookingDfTime;
  } else {
    timeList = time.filter(val => num <= Number(val));
    setMin = timeList[0];
  }

  rootStore.layerStore.setChangeCstTime(setMin);
  rootStore.settingStore.setCookTimeYgy(setMin);
  rootStore.settingStore.setCookTimeList(timeList);
}

// 요기요 고객 예상수령시간 팝업
export function fn_layerCstYgyView(rootStore, mobileOrderNo, mobileOrderFg) {
  fn_removeOrderNew(rootStore, mobileOrderNo);

  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
  rootStore.viewStore.initCustomerPopBtnYgy();

  let cookTime = rootStore.viewStore.getOrderDetail.estimatedCookingTime;
  let setMin;
  let list = [];
  let timeList = [];
  let num = Number(cookTime);

  //요기요 포장
  if (mobileOrderFg == "27") {
    list = ["5", "10", "15", "20", "25", "30", "40", "45", "50", "60"];
    if (num < 5) {
      timeList = list;
      setMin = timeList[0];
    } else if (num > 60) {
      setMin = cookTime;
    } else {
      timeList = list.filter(val => num <= Number(val));
      setMin = timeList[0];
    }
  } else {
    list = ["5", "10", "15", "20", "25", "30"];
    if (num < 5) {
      timeList = list;
      setMin = timeList[0];
    } else if (num > 30) {
      setMin = cookTime;
    } else {
      timeList = list.filter(val => num <= Number(val));
      setMin = timeList[0];
    }
  }

  //rootStore.layerStore.setChangeCstTime(setMin);
  rootStore.settingStore.setCookTimeYgy(setMin);
  rootStore.settingStore.setCookTimeList(timeList);

  let time = "0";
  let view_time = "now";

  view_time = "min" + setMin;
  fn_set_customer_ygy_pop(rootStore, view_time);

  if (rootStore.viewStore.getOrderDetail.isInputCookingTime) {
    if (rootStore.settingStore.getCookTimeList.length != 0) {
      rootStore.layerStore.setLayerCstExpectTimeYgy(true);
    } else {
      fn_layerYgyFixed(rootStore, mobileOrderNo);
    }
  } else {
    fn_layerYgyFixed(rootStore, mobileOrderNo);
  }
}

// 요기요 시간 픽스 팝업
export function fn_layerYgyFixed(rootStore, mobileOrderNo) {
  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
  rootStore.layerStore.setLayerAlertType("order_accept_ygy");
  rootStore.layerStore.setLayerAlertView(true);
}

// 품절 창 열기
export function fn_layerSoldout(rootStore) {
  rootStore.layerStore.setLayerSoldOut(true);
}

// 배달호출 창 닫기
export function fn_closeDeliveryCall(rootStore) {
  rootStore.deliveryStore.setExpDelivery(rootStore.deliveryStore.getExpDelivery);
  rootStore.layerStore.setLayerDeliveryCall(false);
  rootStore.deliveryStore.initDeliveryListFee();
}

// 배달 호출 실패 오류 창
export function fn_deliveryCallFail(rootStore) {
  rootStore.layerStore.setLayerAlertType("dlv_call_fail");
  rootStore.layerStore.setLayerAlertView(true);
}

// 배달 호출 실패 오류 창
export function fn_deliveryCallFailCustom(rootStore, title, message) {
  rootStore.layerStore.setAlertCustomMessage(title);
  rootStore.layerStore.setAlertCustomMessage(message);
  rootStore.layerStore.setLayerAlertType("alert_custom");
  rootStore.layerStore.setLayerAlertView(true);
}

// 배달 취소 실패 오류 창
export function fn_deliveryCancelFail(rootStore) {
  rootStore.layerStore.setLayerAlertType("dlv_cancel_fail");
  rootStore.layerStore.setLayerAlertView(true);
}

// 배달 대행사 조회 실패 오류 창
export function fn_deliveryPartnerFail(rootStore) {
  rootStore.layerStore.setLayerAlertType("dlv_partner_fail");
  rootStore.layerStore.setLayerAlertView(true);
}

// 배달비조회 실패 오류 창
export function fn_deliveryFeeFail(rootStore) {
  rootStore.layerStore.setLayerAlertType("dlv_fee_fail");
  rootStore.layerStore.setLayerAlertView(true);
}

// 주방프린터 출력 알림 창
export function fn_cookingPring(rootStore) {
  fn_bridge_print(rootStore, "4");
  rootStore.layerStore.setLayerAlertType("print_delay");
  rootStore.layerStore.setLayerAlertView(true);
}

// 주문 리스트로 이동
export function fn_orderList(rootStore) {
  const searchStore = rootStore.searchStore;
  if (searchStore.getShopCd && searchStore.getToken) {
    select_access_token(rootStore).then(res => {
      searchStore.setCurrStepType("all");
      reload_order_list_all(rootStore);
    });
  } else {
    // 재설정 처리
    fn_init_info(rootStore);
  }
  return; /*<MainOrderListContainer rootStore={rootStore}/>*/
}

// 배달비조회 실패 오류 창
export function fn_showEndOrderList(rootStore) {
  select_access_token(rootStore).then(res => {
    api_end_order_list(rootStore);
    // 주문탭 완료로 설정
    rootStore.searchStore.setCurrStepType("end");
  });

  return; /*<SettingEndOrderView rootStore={rootStore}/>*/
}

// 품절 확인 창
export function fn_menuSoldOutConfirm(rootStore, type) {
  rootStore.layerStore.setLayerSoldOutConfirmType(type);
  rootStore.layerStore.setLayerSoldOutConfirmView(true);
}

// 자체배달원 등록창
export function fn_deliverySelf(rootStore, obj) {
  const deliveryStore = rootStore.deliveryStore;
  if (obj != null) {
    deliveryStore.setDeliveryAspForm("actionFlag", "U");
    deliveryStore.setDeliveryAspForm("empNo", obj.emp_no);
    deliveryStore.setDeliveryAspForm("empNm", obj.emp_nm);
    deliveryStore.setDeliveryAspForm("isNameValid", true);
    deliveryStore.setDeliveryAspForm("retireFlag", obj.retire_fg);
  }
  rootStore.layerStore.setLayerDeliverySelfView(true);
}

// 자체배달원 수정창
export function fn_deliverySelfEdit(rootStore, obj) {
  rootStore.deliveryStore.setDeliveryAspEmpNo(obj);
  rootStore.layerStore.setLayerDeliverySelfEditView(true);
}

export function fn_deliverySelfClose(rootStore) {
  rootStore.deliveryStore.initDeliveryAspForm();
  rootStore.layerStore.setLayerDeliverySelfView(false);
}

export function fn_self_delivery_complet(rootStore, viewBl, mobileOrderNo, btn) {
  if (rootStore.settingStore.getPosType != "0" && rootStore.settingStore.getPosType != "2") {
    rootStore.layerStore.setLayerAlertType("order_pos");
    rootStore.layerStore.setLayerAlertView(true);
  } else {
    analyticeEvent("orderComplete", btn, rootStore.searchStore.getShopCd); //GA4
    rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);

    rootStore.layerStore.setDepositCheck(rootStore.viewStore.getOrderDetail.payFg == "CARD" ? "02" : "01");
    rootStore.layerStore.setLayerCheckDeposit(viewBl);
  }
}

export function fn_setDepositCheck(rootStore, info) {
  rootStore.layerStore.setDepositCheck(info);
}

// 주문 완료 확인 창
export function fn_order_complete_layer(rootStore, mobileOrderNo, btn) {
  const { layerStore, viewStore, settingStore, orderStore } = rootStore;

  viewStore.setOrderDetail(orderStore.getOrderList, mobileOrderNo);

  if (settingStore.getPosType !== "0" && settingStore.getPosType !== "2") {
    layerStore.setLayerAlertType("order_pos");
    layerStore.setLayerAlertView(true);
  } else if (viewStore.getOrderDetail.mobileOrderFg === MobileOrderFg.YOGIYO_EXPRESS) {
    fn_ygy_order_complete(rootStore);
  } else {
    if (btn) {
      analyticeEvent(
        btn.includes("Pickup") ? "orderPickupComplete" : "orderComplete",
        btn,
        rootStore.searchStore.getShopCd
      ); //GA4
    }
    fn_removeOrderNew(rootStore, mobileOrderNo);
    layerStore.setLayerOrderComplete(true);
  }
}

// pos주문 완료 확인 창
export function fn_pos_order_complete_layer(rootStore, order) {
  rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, order.mobileOrderNo);
  rootStore.layerStore.setLayerOrderComplete(true);
}

export function fn_ygy_order_complete(rootStore) {
  rootStore.layerStore.setLayerAlertType("ygy_order_complete");
  rootStore.layerStore.setLayerAlertView(true);
}

export function fn_add_box_show(rootStore, viewBl) {
  rootStore.viewStore.setAddrBoxShowFlag(viewBl);
}

export function fn_request_memo_delete_layer(rootStore) {
  rootStore.layerStore.setLayerRequestMemoDeleteView(true);
}

export function fn_request_memo_set_type(rootStore, type) {
  rootStore.layerStore.setLayerRequestMemoTypeView(type);
}

export function fn_use_set_type(rootStore, type) {
  rootStore.layerStore.setLayerUseSetTypeView(type);
}

export function fn_receipt_set_type(rootStore, type) {
  rootStore.layerStore.setLayerReceiptSetTypeView(type);
}

export function fn_print_set_type(rootStore, type) {
  rootStore.layerStore.setLayerPrintSetTypeView(type);
}

// POS용 주소창 상세주소 활성화
export function fn_search_address_deail_box_show(rootStore, viewBl) {
  rootStore.addressSearchStore.setAddrBoxShowFlag(viewBl);
}

// POS CID 결제 확인창 활성화
export function fn_order_payment_alert_show(rootStore, mobileOrderNo, btn) {
  if (rootStore.settingStore.getPosType != "0" && rootStore.settingStore.getPosType != "2") {
    rootStore.layerStore.setLayerAlertType("order_pos");
    rootStore.layerStore.setLayerAlertView(true);
  } else {
    analyticeEvent("orderCid", btn, rootStore.searchStore.getShopCd); //GA4
    //detail store 변경
    rootStore.viewStore.setOrderDetail(rootStore.orderStore.getOrderList, mobileOrderNo);
    rootStore.layerStore.setLayerOrderPaymentAlertView(true);
  }
}

//관리자 인증
export function fn_auth_pop(rootStore) {
  //    analyticeEvent("cs", "csVoc Button", rootStore.searchStore.getShopCd) //GA4
  //문의팝업open
  rootStore.layerStore.setLayerAuthView(true);
}

// 배민사용 off
export function fn_orderDetailBaemin(rootStore) {
  rootStore.layerStore.setLayerAlertType("baemin_use_off");
  rootStore.layerStore.setLayerAlertView(true);
}

// 배민 에러
export function fn_connectFailBaemin(rootStore, type, data) {
  rootStore.orderStore.setBaeminFailDetail(data);
  rootStore.viewStore.setOrderDetail([data], data.mobileOrderNo);
  rootStore.layerStore.setLayerAlertType(type);
  rootStore.layerStore.setLayerAlertView(true);
}

// 요기요api 완료주문 취소시 팝업여부
export function fn_ygyEndOrderCancel(rootStore, data, code) {
  if (code == "000") {
    fn_bridge_order_cancel_pos(rootStore, data);
  } else {
    rootStore.layerStore.setLayerAlertType("ygy_cancel");
    rootStore.layerStore.setLayerAlertView(true);
  }
}
